/* eslint-disable quotes */
/*
 * @Author: 吴文洁
 * @Date: 2019-10-15 17:31:25
 * @Last Modified by: wangxiang
 * @Last Modified time: 2021-05-14 11:33:18
 */

import Vue from 'vue';
import Tracker from 'xiaomai-web-sentry';
import 'vue-ydui/dist/ydui.rem.css';
import YDUI from 'vue-ydui';
import 'mint-ui/lib/style.css';
import MintUI from 'mint-ui';
import Vant from 'vant';
import 'vant/lib/index.css';
import Bus from '@/core/bus';
import '@/core/cache';
import '@/core/function';
import '@/core/storage';
import '@/core/cookie';
import '@/core/enum';
import '@/core/exception';
import '@/core/config';
import '@/core/promise';
import '@/service/Axios';
import '@/AppConfig';
import '@/store/dispatch';
import '@/core/traceLog';
import { Confirms } from '@/components/globleComponents/Confirm/index';

import store from '@/store';
import router from '@/router';
import LoginService from '@/service/LoginService';
import UserService from '@/service/UserService';
import { isUndefined,is_android } from '@/core/util';
import Platform from '@/core/platform';
import User from '@/core/user';
import App from './App';
import '../assets/style/comon.css'; // global css
import PortalVue from 'portal-vue';

Vue.use(Vant);
Vue.use(MintUI);
Vue.use(YDUI);
Vue.use(PortalVue);
console.log(wx);
wx.miniProgram.getEnv(res => {
  window.Cache.set('brandMiniapp', res.miniprogram);
});

Vue.prototype.$Confirm = Confirms;
Vue.prototype.$EventBus = new Vue();
Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-subscribe'];
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
console.log('env', wx);
// 判断小程序环境
wx.miniProgram.getEnv(res => {
  console.log('miniprogram', res);
});

const code = window.getParameterByName('code');
const instId = window.getParameterByName('instId');
const tenantId = window.getParameterByName('tenantId');
const tenantType = window.getParameterByName('tenantType');
console.log(window, 'window');
if (window.location.href.indexOf('fromBrandMiniapp') != -1) {
  if (instId) {
    sessionStorage.setItem('brandInstId', instId);
  }
  if (tenantId) {
    sessionStorage.setItem('brandTenantId', tenantId);
  }
  if (tenantType) {
    sessionStorage.setItem('brandTenantType', tenantType);
  }
  if (window.getParameterByName('instType')) {
    sessionStorage.setItem('brandInstType', window.getParameterByName('instType'));
  }
  sessionStorage.setItem('brandMiniapp', true);
  localStorage.setItem('fromBrandMiniapp', true);
  const token = window.getParameterByName('token');
  const uid = window.getParameterByName('uid');
  if (token && !User.openId()) {
    // User.setToken(token)
    // console.log(User.appId())
    const key = 'weixin_token_' + User.appId();
    window.localStorage.removeItem(key);
  }
  // if (uid) {
  //   User.setUid(uid)
  // }
  // eslint-disable-next-line keyword-spacing
} else {
  localStorage.removeItem('fromBrandMiniapp', true);
}

if (!User.appId()) {
  if (window.TDAPP) {
    window.TDAPP.onEvent(window.encryptCode(), null, {
      href: location.href,
    });
  }
}

const getMergeBindStudentList = async () => {
  const appId = User.appId();
  UserService.getMergeBindStudentList(appId)
    .then(res => {
      const { result } = res;
      User.setBindStudentList(result);
      if (isUndefined(User.currentInstOfBind()) && result.length) {
        const currentInstOfBind = result[0].groupStudentVOList[0] || {};
        User.setCurrentInstOfBind(currentInstOfBind);
      }
    })
    .catch(err => {
      throw new Error(err);
    });
};

function loadAppComp() {
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
      App,
    },
  });
  // // 手机端调试;
  // const obj = {
  //   weixin_token_wx5c5a1fb71ecab7bc: '04a3c0d42e5f445e8288003bd5b7de20',
  //   c_weixin_token_wx5c5a1fb71ecab7bc: '04a3c0d42e5f445e8288003bd5b7de20',
  //   c_weixin_uid_wx5c5a1fb71ecab7bc: '1411980183062839298',
  //   weixin_uid_wx5c5a1fb71ecab7bc: '1411980183062839298',
  //   appid: 'wx5c5a1fb71ecab7bc',
  //   c_appid: 'wx5c5a1fb71ecab7bc',
  //   xiaomai_appid: 'wx5c5a1fb71ecab7bc',
  //   c_weixin_openId_wx5c5a1fb71ecab7bc: 'ogxi2w8MLpKYNQ4ZlJTEcro-EczI',
  //   weixin_openId_wx5c5a1fb71ecab7bc: 'ogxi2w8MLpKYNQ4ZlJTEcro-EczI',
  //   weixin_phone: '13772986952',
  // };
  // for (const key in obj) {
  //   localStorage.setItem(key, obj[key]);
  // }
}

function renderApp() {
  loadAppComp();
}
function getUserInfoById() {
  axios.Customer('public/user/getUserInfoById', {
    xmToken: User.token(),
    appId: User.appId(),
  })
  .then(res => {
    res.result.id && User.setUid(res.result.id); //有token   获取到userId
    User.setOpenId(res.result.openId);
    User.setPhone(res.result.bindPhone);
    window.userConfig = res.result;
    renderApp();
  })
  .catch(() => {
    //获取userId 异常
    localStorage.clear();
    window.Cache.clear();
    renderApp();
  });
}

function changeBindPhone(accountId, uid, hasToken) {
   axios.Customer("public/login/changeAccountUser", {
      accountId,
      userId: uid,
      skipCodeCheck: true,
    }).then((res) => {
      User.setUid(uid);
      const token = window.getParameterByName('token');
      token && User.setToken(token);
      User.setOpenId(res.result.openId);
      if (hasToken) {
        renderApp();
      } else {
        getUserInfoById();
      }
    }).catch(() => {
      renderApp();
    });
}
function loginWechatCode() {
  axios
      .Customer('anon/login/loginByWeChatCode', {
        appId: User.appId(),
        appTermEnum: 'CUSTOMER_WECHAT_H5',
        code: code,
      }).then((res) => {
        const uid = window.getParameterByName('uid');
        User.setOpenId(res.result.openId);
        User.setUid(res.result.userId);
        User.setToken(res.result.xmToken);
        window.userConfig = res.result;
        changeBindPhone(res.result.accountId, uid, false);
      });
}
const Browser = Tracker.Browser;
const browser = new Browser();
const initParams = {
  project: 'xiaomai-web-parents',
  userId: User.uid(),
  env: process.env.DEPLOY_ENV || 'test',
};
browser.init(initParams);

const VuePlugin = Tracker.VuePlugin;
new VuePlugin(Vue, initParams);
window.isAndroid = is_android();
window.userConfig = {};
if (code && Platform.isWeiXin()) {
  if (
    location.hash.indexOf('/inst/home') === -1 &&
    location.hash.indexOf('transfer/index') === -1 &&
    location.hash.indexOf('transfer/posterImage') === -1 &&
    location.hash.indexOf('xm/pre/pay') === -1 &&
    location.hash.indexOf('xm/tl/pay') === -1 &&
    location.hash.indexOf('aiFamilyPay') === -1 &&
    location.hash.indexOf('online/order/confirm') === -1 &&
    location.hash.indexOf('insure') === -1 &&
    !User.token()
  ) {
    axios
      .Customer('anon/login/loginByWeChatCode', {
        appId: User.appId(),
        appTermEnum: 'CUSTOMER_WECHAT_H5',
        code: code,
      })
      .then(res => {
        User.setOpenId(res.result.openId);
        User.setUid(res.result.userId);
        User.setToken(res.result.xmToken);
        window.userConfig = res.result;
        clearTimeout(window.loginTimer);
        const uid = window.getParameterByName('uid');
        const token = window.getParameterByName('token');
        const result = uid != res.result.userId ? true : false;
        if (window.location.href.indexOf('fromBrandMiniapp') != -1 && uid && token && result && uid != 0) {
          changeBindPhone(res.result.accountId, uid, true);
        } else {
          renderApp();
        }
      })
      .catch(() => {
        Vue.$wheatToast({
          message: '自动登录失败,请稍后再试',
          position: "middle"
        });
        window.XMTDEVENT('自动登录失败，报500', {
          appTerm: 'GZH',
          certificate: code,
          instId: instId || '1000000000000000000',
          loginType: 'WE_CHAT',
          userType: 'C',
          appId: User.appId(),
        });
        document.body.innerHTML = `<div style="display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;">
            <div>账号登录过频繁</div>
            <div>请稍后再试</div>
          </div>
        `;
      });
  } else {
    if (
      location.hash.indexOf('/inst/home') === -1 &&
      location.hash.indexOf('transfer/index') === -1 &&
      location.hash.indexOf('xm/pre/pay') === -1 &&
      location.hash.indexOf('aiFamilyPay') === -1 &&
      location.hash.indexOf('xm/tl/pay') === -1 &&
      location.hash.indexOf('insure') === -1 &&
      User.token()
    ) {
      console.log(194);
      const uid = window.getParameterByName('uid');
      const token = window.getParameterByName('token');
      if (window.location.href.indexOf('fromBrandMiniapp') != -1 && User.uid() != uid && uid && token && uid != 0) {
        loginWechatCode();
      } else {
        getUserInfoById();
      }
    } else {
      renderApp();
    }
  }
} else {
  //没有code  instId
  if (User.token() && location.hash.indexOf('insure') === -1) {
    console.log(219);
    axios
      .Customer('public/user/getUserInfoById', {
        xmToken: User.token(),
        appId: User.appId(),
      })
      .then(res => {
        res.result.id && User.setUid(res.result.id); //有token   获取到userId
        User.setOpenId(res.result.openId);
        User.setPhone(res.result.bindPhone);
        window.userConfig = res.result;
        renderApp();
      })
      .catch(() => {
        //获取userId 异常
        renderApp();
      });
  } else {
    renderApp();
  }
}




// WEBPACK FOOTER //
// ./src/main.js